<script>
    import IconSearch from '@/components/icon/IconSearch.vue';

    export default {
        components: {
            ButtonIcon: IconSearch,
        },
        props: {
            title: String,
            method: Function,
        },
        methods: {
            async clickButton() {
                this.method();
            }
        }
    }
</script>


<template>
    <button 
        class="left_button_main_container"
        @click="clickButton"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">{{ title }}</label>
        </div>
    </button>
</template>